<template>
  <NoticeGlobal
    class="billing-special-offer-notice-global"
    :commonActionButtonText="tt('shared.action.learn')"
    closable
    @clickCommonActionButton="handleSpecialOfferReadingConfirm"
    @close="$emit('close')"
  >
    <template #text>
      <label>
        {{ tt('billing.specialOfferNoticeGlobal.specialPlanConditions') }}
      </label>
    </template>
  </NoticeGlobal>
</template>

<script lang="ts">

import { defineComponent } from 'vue';

import { NoticeGlobal } from '@/ui';
import {
  ESize,
  EButtonType,
  ENoticeType,
} from '@/ui/types';
import tt from '@/i18n/utils/translateText';

import { useConfirmReadingSpecialOffer } from './application/useConfirmReadingSpecialOffer';

export default defineComponent({
  name: 'BillingSpecialOfferNoticeGlobal',
  components: { NoticeGlobal },
  emits: ['close'],
  setup() {
    const {
      isLoading,
      specialOffer,

      handleSpecialOfferReadingConfirm,
    } = useConfirmReadingSpecialOffer();

    return {
      isLoading,
      specialOffer,
      ESize,
      EButtonType,
      ENoticeType,

      tt,
      handleSpecialOfferReadingConfirm,
    };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
